export default class CepService {
    public get(cep: string): Promise<Response> {
        return fetch(`//viacep.com.br/ws/${cep}/json`);
    }
}
